import React, { useState, useEffect } from 'react';
import { Table, Pagination, Checkbox } from 'antd';
import Row from 'react-bootstrap/Row';
import Button from 'react-bootstrap/Button';
import { set } from 'immutable';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import axios from 'axios';
import moment from 'moment';
import { Input } from 'antd';
import Select from 'react-select';
import Form from 'react-bootstrap/Form';
import { FaMinusCircle } from 'react-icons/fa';

import { useForm, Controller, Feedback } from 'react-hook-form';
import DatePicker from 'react-datepicker';





import Col from 'react-bootstrap/Col';
import Spinner from 'react-bootstrap/Spinner';
import { URL_EMPLOYEE } from '../../constans/servidor';
import PaginationComponent from '../Desenganche/pagination';
import Formulario from './Formulario';
import { NavItem } from 'react-bootstrap';

const TableComponent = props => {
  const { data } = props;
  const [loadingData, setLoadingData] = useState(false);
  const [contracto, setContrato] = useState()
  const [compañia, setCompañia] = useState()
  const [id, setID] = useState()
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [placa, setPlaca] = useState();
  const [placass, setPlacass] = useState();
  const [estado, setEstado] = useState();
  const [fecha_hora, setFecha_hora] = useState([]);
  const [nom_terminal, setNom_terminal] = useState();
  const [cod_terminal, setCod_terminal] = useState();
  const [cod_park, setCod_park] = useState();
  const [modal, setModal] = useState(false);
  const [modal1, setModal1] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [buscar, setBuscar] = useState(data);
  const [dplaca, setdPlaca] = useState([]);
  const [dplaca1, setdPlaca1] = useState([]);
  const [dplaca2, setdPlaca2] = useState([]);
  const [dataPagination, setDataPagination] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [filterData, setFilterData] = useState([]);
  const [objeto, setObjeto] = useState([]);
  const [crear, setCrear] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false)
    }, 800);
  }, []);


  let handleSearch = ''
  let handleRowClick = ''
  let filteredData = ''

  const {
    control,
    watch,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();


  useEffect(() => {
    console.log('data');
    console.log(data);
    setFilterData(data);
    setTimeout(() => {
      setEstado(1)
    }, 800);
  }, [data]);

  const Datos = async (contracto, compania, id) => {
    setModal(true)
    setContrato(contracto)
    setCompañia(compania)
    setID(id)
  }

  

  handleSearch = (event) => {
    const inputValue = event.target.value || ''; // Si es nulo, establece una cadena vacía
    setSearchTerm(inputValue);
  };
  filteredData = dataPagination.filter((row) =>
  Object.values(row).some((value) =>
    value !== null && value.toString().toLowerCase().includes(searchTerm.toLowerCase())
  )
);
  let filteredResults = filteredData;
  let valor

  if (filteredResults.length === 0) {
    valor = true
  }



  return (
    loading ? (
      <div className="cargando">
        <div className="loader" id="loader">
          Loading...
        </div>
      </div>
    ) : (
      <div >
        {data ? (
          <>
            <Row className="justify-content-end mbottom-40" >
              <input className='buscar inputplaca' type="text" placeholder="Search..." onChange={handleSearch} />
            </Row>
            <table className='tabla '>
              <thead>
                <tr>
                  <th>Nombre Convenio</th>
                  <th>Cod Park</th>
                  <th>Tipo Convenio</th>
                  <th>Fecha Act</th>
                  <th>Fecha Exp</th>
                </tr>
              </thead>
              <tbody>
                {filteredData.map((row) => (
                  <tr >
                    <td>{row.nombre_convenio}</td>
                    <td>{row.cod_park}</td>
                    <td>{row.tipo_convenio}</td>
                    <td>{moment.utc(row.fecha_inicial).format('DD/MM/YYYY')}</td>
                    <td>{moment.utc(row.fecha_final).format('DD/MM/YYYY')}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="float-right pagination">
              <PaginationComponent
                data={data}
                setDataPagination={setDataPagination}
                title="Posts"
                pageLimit={10}
                dataLimit={50}
              />
            </div>
          </>
        ) : null}
      </div>

    )
  );
};

export default TableComponent;
